import React from 'react';
import { HalfDoughnutChart } from '../charts/HalfDoughnutChart';
import { Information } from '../Information';
import { t } from '../../i18n';

const Partials = ({ value, total }: Props) => {
  const mainColor = '#9555E9';
  const restColor = '#EDE2FF';
  const percentage = value !== 0 && total !== 0 ? Math.round((value / total) * 100) : 0;
  const rest = 100 - percentage;
  const datasets = [{ data: [ { value: percentage, label: percentage + '%' }, { value: rest, label: rest + '%' } ], backgroundColor: [ mainColor, restColor ]}];
  const labels = ['P', 'R'];
  return (
    <div className="d-flex">
      <div className="d-flex flex-column h-100">
        <div className="d-flex align-items-center">
          <Information id="partially" content={<small className="text-gray-09 me-2">{t('mediaPlayback.partially')}</small>} />  
          <Information id="partially" showMore={true} />
        </div>
        <div className="flex-grow-1" style={{ width: 63 }}>
          <HalfDoughnutChart datasets={datasets} labels={labels} />
        </div>
      </div>
      <div className="ms-3">
        <h1 className="mb-0 text-gray-12">{value}</h1>
        <div className="text-gray-09 fs-7">{t('common.ofTotal', { percentage })}</div>
      </div>
    </div>
  );
}

interface Props {
  value: number,
  total: number
}

export { Partials };